import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'

const qsSelectorState = state => state.qs

const loginLmsSelector = createSelector(
	[qsSelectorState],
	qsSelectorData => {
		let lmsType = ' '
		if (qsSelectorData.referer.search('::LMS_TYPE::1') !== -1) {
			lmsType = ' Canvas '
		}
		if (qsSelectorData.referer.search('::LMS_TYPE::2') !== -1) {
			lmsType = ' Schoology '
		}
		if (qsSelectorData.referer.search('::LMS_TYPE::3') !== -1) {
			lmsType = ' Blackboard '
		}
		if (qsSelectorData.referer.search('::LMS_TYPE::5') !== -1) {
			lmsType = ' ItsLearning '
		}

		return {
			lmsConfirmText: localize('lms_confirm_text_part1') + lmsType + localize('lms_confirm_text_part2'),
		}
	}
)

export default loginLmsSelector
